// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-Order-SubscriptionBuy-List-StatusTag-css-module__statusTag--1t6Bd"};